import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Modal, ModalControlResponse, PrimaryButton, SecondaryButton, Text, XIcon } from '@frontend/design-system';
import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';

interface ModalProps {
  removeSyncModal: ModalControlResponse;
}

export const RemoveSyncModal: FC<React.PropsWithChildren<ModalProps>> = ({ removeSyncModal }) => {
  const { t } = useTranslation('phoneSync');

  const handleRemoveSync = (): void => {
    removeSyncModal.closeModal();
  };

  return (
    <Modal {...removeSyncModal.modalProps} maxWidth={400}>
      <Modal.Header textAlign='left'>{t('Remove Sync?')}</Modal.Header>
      <XIcon
        color='light'
        css={css`
          position: absolute;
          right: ${theme.spacing(3)};
          top: ${theme.spacing(3.5)};
          font-weight: bold;
          cursor: pointer;
        `}
        onClick={removeSyncModal.closeModal}
      />
      <Modal.Body>
        <Text
          css={css`
            max-width: ${theme.spacing(43)};
          `}
        >
          {t('Are you sure you want to remove the sync between Weave and your desk phone?')}
        </Text>
        <div
          css={css`
            display: flex;
            justify-content: flex-end;
            margin-top: ${theme.spacing(4)};
          `}
        >
          <SecondaryButton
            size='large'
            css={css`
              width: fit-content;
            `}
            onClick={removeSyncModal.closeModal}
          >
            {t('Cancel')}
          </SecondaryButton>
          <PrimaryButton
            size='large'
            css={css`
              width: fit-content;
              margin-left: ${theme.spacing(1)};
              background-color: ${theme.colors.critical50};
              border-color: ${theme.colors.critical50};
              :hover {
                background-color: ${theme.colors.critical70};
                border-color: ${theme.colors.critical70};
              }
            `}
            onClick={handleRemoveSync}
          >
            {t('Yes, Remove')}
          </PrimaryButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};
